import { render, staticRenderFns } from "./questionRule.vue?vue&type=template&id=262f05e6&scoped=true&"
import script from "./questionRule.vue?vue&type=script&lang=ts&"
export * from "./questionRule.vue?vue&type=script&lang=ts&"
import style0 from "./questionRule.vue?vue&type=style&index=0&id=262f05e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "262f05e6",
  null
  
)

export default component.exports